import React, { useState } from 'react'
import { connect } from 'react-redux'
import { StoreState } from '../../state/configureStore'
import { AnyAction, Dispatch } from 'redux'
import { renameMachine } from '../../state/actions/machine'
import { Text } from 'recharts'
import { MachineDetails } from './machineDetails'
import { SaveModal } from '../../components/molecules/SavingModal'
import { PatchToBackoffice } from '../../utils/commands'

type IComponentProps = IComponentOwnProps & IComponentStoreProps & IComponentDispatchProps;

type IComponentStoreProps = ReturnType<typeof mapStateToProps>;
type IComponentDispatchProps = ReturnType<typeof mapDispatchToProps>;

interface IComponentOwnProps {
  open: boolean;
  closeModal: Function;
  details: MachineDetails | undefined;
}

function VerifyFlashModal(props: IComponentProps): React.ReactElement {

  const [savingStatus, setSavingStatus] = useState<boolean>(false)
  const [savingFailed, setSavingFailed] = useState<boolean | null>(null)

  const onVerify = () => {
    setSavingStatus(true)
    PatchToBackoffice("machines/flash-ATMega", {serialNumbers: [props.details?.serialNumber]})
      .then((res) => {
        setSavingStatus(false)
        setSavingFailed(!res.successful.includes(props.details?.serialNumber))
      })
  }

  return (
    <SaveModal
      title={'Flash firmware to machine'}
      open={props.open}
      savingFailedMessage={'Flashing failed! Try again later.'}
      savingSuccessMessage={'Flashing successful.'}
      saveButtonText={'Flash'}
      closeModal={() => { props.closeModal() }} 
      onSave={onVerify}
      saving={savingStatus}
      savingFailed={savingFailed === true}
      savingSuccessful={savingFailed === false}
      setSavingFailed={setSavingFailed}>
      <Text> 
        This action will flash new firmware to the machine. 
        Ensure that the affected store is notified beforehand. 
        Please note that the process may take up to 5 minutes, during which the machine will be unavailable for use.  
      </Text>
    </SaveModal>
  )
}

const mapStateToProps = (state: StoreState) => ({
  machine_saving: state.machine_saving
})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  renameMachine: (id: string, name: string) => dispatch(renameMachine(id, name))
})

export default connect(mapStateToProps, mapDispatchToProps)(VerifyFlashModal)